module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6n5r1r-6280e73a77e7f1beded73b6421712ac4.svg";